export function hashPassword(password: string) {
  return import(
    '@shopee-user/authentication-utils/src/crypto'
  ).then(({ sha256, md5 }) => sha256(md5(password).toString()).toString());
}
